export const SEGMENT_DIVISIONS = 20;
